export const convertHtmlToText = (str: string = ''): string => {
  let text = str;

  // Replace &nbsp; with space
  text = text?.replace(/&nbsp;/gi, ' ');
  // Replace br or div with new line
  text = text?.replace(/<br>|<div>/gi, '\n');
  // Replace other tags with empty string
  text = text?.replace(/<(.*?)>/g, '');

  return text;
};
